'use strict';

var util = require('../../util/property-util');
var arrayUtil = require('../../util/array-util');
var MessageDescriptorConvertFactory = require('../../shared/messageDescriptorConvertFactory');

module.exports = /*@ngInject*/ ["$scope","$rootScope", "$q", "UrlRoutingFactory", "ProjectService", "MessageDataRepository", "trainData", "TrainService", "$state", "ConfigurationStoreService", "$filter",
 function($scope, $rootScope, $q, UrlRoutingFactory, ProjectService, MessageDataRepository, trainData, TrainService, $state, ConfigurationStoreService, $filter) {
    var base = this;
    base.loading = true;
    base.trainData = trainData;
    base.children = [];
    base.backButton = undefined;
    $rootScope.$on('project-config-updated', () => init());
    base.parentState = $state.$current && $state.$current.parent && $state.$current.parent.name;
    var init = function () {
        var projectConfiguration = ConfigurationStoreService.getProjectConfiguration( ProjectService.getSelectedProjectId());
        var hiddenTabs = projectConfiguration && projectConfiguration.graphAnalysis && projectConfiguration.graphAnalysis.hiddenTabs;

        var MAR3 = 0;
        base.config = 2;
        "use strict";
        base.children = [
            {
                view: 'chart',
                header: 'I18N_TRIP.TAB_CHART',
                active: false,
                disabled: false,
                visible: true,
                loaded: {
                    deferred: $q.defer(),
                    promise: undefined
                }
            }, {
                view: 'coverage-map',
                header: 'I18N_TRIP.TAB_COVERAGE_MAP',
                active: false,
                disabled: false,
                visible: true,
                loaded: {
                    deferred: $q.defer(),
                    promise: undefined
                }
            }, {
                view: 'vu',
                header: 'I18N_TRIP.TAB_VIRTUAL_USER',
                active: false,
                disabled: false,
                visible: true,
                loaded: {
                    deferred: $q.defer(),
                    promise: undefined
                }
            }, {
                view: 'position',
                header: 'I18N_TRIP.TAB_COMPARE_TRIPS',
                active: false,
                disabled: false,
                visible: trainData && trainData.isTrip,
                loaded: {
                    deferred: $q.defer(),
                    promise: undefined
                }
            }
        ];

        base.children  = base.children.filter(child => child.view === 'chart' || !hiddenTabs || !hiddenTabs.find(tab => tab.toLowerCase() === child.view.toLowerCase()))
        
        base.children.forEach(function (child) {
            child.loaded.promise = child.loaded.deferred.promise;
        });

        var savedTab = $state.current.name.replace(`${base.parentState}.`,'');
        if (util.isDefined(savedTab)) {
            if (base.getChildByName(savedTab)) {
                base.getChildByName(savedTab).active = true;
                setTimeout(() =>  $scope.$broadcast('activate-' + savedTab), 0);
            }

        }
        base.excludeClass = ['tab-content', 'tab-pane'];
        // clear the repository's cache
        MessageDataRepository.clearCache();
        base.config = MAR3;
        base.loading = false;

        switch (base.parentState) {
            case 'trip-analysis':
                base.pageTitle = 'I18N_TRIP.TRIP_ANALYSIS';
                base.backButton = {
                    name: 'I18N_TRIP.TRIPS_OVERVIEW',
                    state: 'trips-overview'
                }
            break;
            case 'period':
                base.pageTitle = 'I18N_TRIP.PERIOD_ANALYSIS';
            break;
            case 'period-analysis':
                base.pageTitle = 'I18N_TRIP.PERIOD_ANALYSIS';
                break;
        }
    };

    base.activate = function (child) {
        "use strict";
        base.children.forEach((currentChild) => {
            currentChild.active = false;
            if (currentChild.view === child.view) {
                currentChild.active = true;
            }
        });

        $state.go(`${base.parentState}.${child.view}`);
        setTimeout(() =>  $scope.$broadcast('activate-' + child.view), 0);
    };

    base.deActivate = function (child) {
        child.active = false;
        "use strict";
        $scope.$broadcast('de-activate-' + child.view);
    };

    base.getChildByName = function (name) {
        "use strict";
        return arrayUtil.getFirstInList(base.children, 'view', name);
    };

    base.reloadPeriod = (params) => {
        base.loading = true;
        params.startDate = $filter('date')( params.startDate, 'yyyy-MM-dd-HH:mm');
        params.endDate = $filter('date')(params.endDate, 'yyyy-MM-dd-HH:mm');
        if ($state.current.name === 'period.search') {
            $state.go(`period-analysis.chart`, params);
        } else {
            $state.go(`period-analysis.${$state.current.name.replace(`${base.parentState}.`,'') || 'chart'}`, params, {
                reload: true
            });
        }
    };
  
    base.changeTrip = (params) => {
        base.loading = true;
        $state.go('trip-analysis.chart', params);
    };
    
    base.goToMonitoring = () => {
        $state.go('monitoring-detail', {
            projectId: base.trainData.projectId, 
            trainId: base.trainData.relativeTrainId
        });
    }

    base.goToSearch = (state) => {
        $state.go(state, {
            projectId: base.trainData.projectId
        }, {
            reload: true
        })
    }

    init();

    
}];

